module.exports = __webpack_public_path__ + "static/media/cool-company.d69112bc.svg";